/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Fields_Item1Inputs */

const ja_playdata_about_fields_item1 = /** @type {(inputs: Playdata_About_Fields_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーミング配信の同時視聴者数と配信時間`)
};

const en_playdata_about_fields_item1 = /** @type {(inputs: Playdata_About_Fields_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concurrent viewers and broadcast duration for each stream.`)
};

/**
* | output |
* | --- |
* | "Concurrent viewers and broadcast duration for each stream." |
*
* @param {Playdata_About_Fields_Item1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_fields_item1 = /** @type {((inputs?: Playdata_About_Fields_Item1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Fields_Item1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_fields_item1(inputs)
	return en_playdata_about_fields_item1(inputs)
});